/* Pro Life Journal theme scripts. Library files in assets/js/lib and lightbox.js / pagination.js come from Source. */

/* Today's date (the server-rendered date can be cached). data-plj-today="numeric" = MM/DD/YY */
(function () {
    const now = new Date();
    document.querySelectorAll('[data-plj-today]').forEach(function (el) {
        if (el.getAttribute('data-plj-today') === 'numeric') {
            const pad = function (n) { return String(n).padStart(2, '0'); };
            el.textContent = pad(now.getMonth() + 1) + '/' + pad(now.getDate()) + '/' + String(now.getFullYear()).slice(-2);
            return;
        }
        try {
            el.textContent = now.toLocaleDateString(document.documentElement.lang || 'en-US', {year: 'numeric', month: 'long', day: 'numeric'});
        } catch (e) { /* keep server date */ }
    });
})();

/* Menu links that are only an anchor (e.g. a "#" placeholder) are never the current page: Ghost would otherwise
   highlight them on the homepage */
document.querySelectorAll('.nav-current > a[href^="#"]').forEach(function (link) {
    link.parentElement.classList.remove('nav-current');
});

/* Menu row: centred while it fits; when it doesn't, it scrolls sideways with a fade on the right until the end */
document.querySelectorAll('[data-plj-nav-scroll]').forEach(function (row) {
    const atEnd = function () {
        row.classList.toggle('is-at-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
    };
    const measure = function () {
        row.classList.remove('is-scrollable');
        row.classList.toggle('is-scrollable', row.scrollWidth > row.clientWidth + 1);
        atEnd();
    };
    measure();
    window.addEventListener('resize', measure);
    row.addEventListener('scroll', atEnd, {passive: true});
    if (document.fonts) document.fonts.ready.then(measure);
});

/* Newsletter sign-ups to Kit (forms with data-plj-kit): sent in the background, the way Kit's own script does it,
   with the result shown in the form ("Check your inbox" or the error). Kit then emails a confirmation link. */
document.querySelectorAll('form[data-plj-kit]').forEach(function (form) {
    const error = form.querySelector('[data-plj-kit-error]');
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (form.classList.contains('loading')) return;
        const data = new FormData(form);
        data.append('referrer', document.referrer);
        data.append('host', window.location.href);
        form.classList.remove('success', 'error');
        form.classList.add('loading');
        if (error) error.textContent = '';
        fetch(form.action, {method: 'POST', body: data, headers: {Accept: 'application/json', 'X-CKJS-Version': '6'}})
            .then(function (response) {
                return response.json().catch(function () { return {}; }).then(function (json) {
                    if (response.ok && json.status === 'success') return;
                    const messages = json.errors && json.errors.messages;
                    throw new Error(messages && messages.length ? messages.join(' ') : 'Something went wrong. Please try again.');
                });
            })
            .then(function () {
                form.classList.add('success');
                form.querySelectorAll('input, button').forEach(function (el) { el.disabled = true; });
            })
            .catch(function (err) {
                form.classList.add('error');
                if (error) error.textContent = err && err.message && err.message !== 'Failed to fetch' ? err.message : 'Something went wrong. Please try again.';
            })
            .then(function () {
                form.classList.remove('loading');
            });
    });
});

/* Subscribe buttons (Kit setting): jump to the first newsletter form visible on this page and put the cursor in it.
   Pages without one (or no JavaScript) follow the link to /subscribe/. */
document.querySelectorAll('[data-plj-subscribe]').forEach(function (button) {
    button.addEventListener('click', function (e) {
        const field = Array.prototype.find.call(document.querySelectorAll('form[data-plj-kit] input[type="email"]'), function (input) {
            return input.offsetParent !== null && !input.closest('.m-bar, .plj-drawer');
        });
        if (!field) return;
        e.preventDefault();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        field.focus({preventScroll: true});   // focus first: focusing during a smooth scroll cancels it
        field.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'center'});
    });
});

/* Masthead + Ledger: analog clock, verse of the day, days since Dobbs, live abortion estimate, ban map */
(function () {
    const DOBBS = Date.UTC(2022, 5, 24);   // Dobbs v. Jackson Women's Health Organization, June 24, 2022
    const now = new Date();

    // Verse of the day: a pro-life verse (RSV-2CE), the same for everyone on a given date.
    // Text checked against the RSV Catholic Edition; these verses have no archaic pronouns, which is where the
    // Second Catholic Edition differs. Copyright notice: partials/components/footer.hbs.
    const VERSES = [
        ['Before I formed you in the womb I knew you, and before you were born I consecrated you; I appointed you a prophet to the nations.', 'Jeremiah 1:5'],
        ['Lo, sons are a heritage from the LORD, the fruit of the womb a reward.', 'Psalm 127:3'],
        ['So God created man in his own image, in the image of God he created him; male and female he created them.', 'Genesis 1:27'],
        ['You shall not kill.', 'Exodus 20:13'],
        ['Open your mouth for the dumb, for the rights of all who are left desolate.', 'Proverbs 31:8'],
        ['I have set before you life and death, blessing and curse; therefore choose life, that you and your descendants may live.', 'Deuteronomy 30:19'],
        ['For behold, when the voice of your greeting came to my ears, the babe in my womb leaped for joy.', 'Luke 1:44'],
        ['And when Elizabeth heard the greeting of Mary, the babe leaped in her womb; and Elizabeth was filled with the Holy Spirit.', 'Luke 1:41'],
        ['Did not he who made me in the womb make him? And did not one fashion us in the womb?', 'Job 31:15'],
        ['Let the children come to me, do not hinder them; for to such belongs the kingdom of God.', 'Mark 10:14'],
        ['Give justice to the weak and the fatherless; maintain the right of the afflicted and the destitute.', 'Psalm 82:3'],
        ['So it is not the will of my Father who is in heaven that one of these little ones should perish.', 'Matthew 18:14'],
        ['The LORD called me from the womb, from the body of my mother he named my name.', 'Isaiah 49:1'],
        ['I came that they may have life, and have it abundantly.', 'John 10:10'],
        ['Thus says the LORD, your Redeemer, who formed you from the womb\u2026', 'Isaiah 44:24'],
        ['Rescue those who are being taken away to death; hold back those who are stumbling to the slaughter.', 'Proverbs 24:11']
    ];
    const dayNumber = Math.floor((Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) - Date.UTC(2024, 0, 1)) / 86400000);
    const verse = VERSES[((dayNumber % VERSES.length) + VERSES.length) % VERSES.length];
    document.querySelectorAll('[data-plj-verse]').forEach(function (el) {
        const text = el.querySelector('.m-verse-text');
        const ref = el.querySelector('.m-verse-ref');
        if (text) {
            // The closing quote sits in its own span so it can tuck up to the full stop (the italic leaves a gap)
            text.textContent = '\u201c' + verse[0];
            const close = document.createElement('span');
            close.className = 'm-verse-close';
            close.textContent = '\u201d';
            text.appendChild(close);
        }
        if (ref) ref.textContent = verse[1];
        el.title = verse[0] + ' (' + verse[1] + ', RSV-2CE)';
    });

    // Days since Dobbs
    const days = Math.floor((Date.now() - DOBBS) / 86400000).toLocaleString('en-US');
    document.querySelectorAll('[data-plj-dobbs-days]').forEach(function (el) { el.textContent = days; });

    // Analog clock in the masthead: hands show the reader's local time
    const clock = document.querySelector('[data-plj-clock]');
    function tickTime() {
        if (!clock) return;
        const t = new Date();
        const h = t.getHours() % 12, m = t.getMinutes();
        clock.querySelector('.m-clock-h').setAttribute('transform', 'rotate(' + (h * 30 + m * 0.5) + ' 16 16)');
        clock.querySelector('.m-clock-m').setAttribute('transform', 'rotate(' + (m * 6) + ' 16 16)');
        clock.setAttribute('aria-label', t.toLocaleTimeString('en-US', {hour: 'numeric', minute: '2-digit'}));
    }
    tickTime();
    if (clock) setInterval(tickTime, 30000);

    // Ledger: live estimate of abortions in the U.S. so far this year (annual total from theme settings).
    // Works for every Ledger on the page.
    document.querySelectorAll('[data-plj-estimate]').forEach(function (counter) {
        const perYear = parseInt(String(counter.getAttribute('data-per-year')).replace(/[^0-9]/g, ''), 10);
        if (!(perYear > 0)) return;
        const box = counter.closest('.m-ledger') || document;
        const year = new Date().getFullYear();
        const start = Date.UTC(year, 0, 1, 5);                 // Jan 1, 00:00 US Eastern
        const yearMs = Date.UTC(year + 1, 0, 1, 5) - start;
        const perMs = perYear / yearMs;
        const chart = box.querySelector('[data-plj-year-chart]');
        if (chart) {
            // Gridlines every 250,000, and the year-end total the dashed pace line runs to
            const plot = chart.querySelector('.m-ledger-plot');
            for (let v = 250000; v < perYear * 0.94; v += 250000) {
                const grid = document.createElement('span');
                grid.className = 'm-ledger-grid';
                grid.style.bottom = (v / perYear * 100).toFixed(2) + '%';
                grid.setAttribute('data-label', v >= 1e6 ? (v / 1e6) + 'M' : (v / 1000) + 'K');
                plot.insertBefore(grid, plot.firstChild);
            }
            const total = chart.querySelector('[data-plj-chart-total]');
            if (total) total.textContent = (perYear / 1e6).toFixed(2) + 'M';
        }
        const everyEl = box.querySelector('[data-plj-every]');
        if (everyEl) everyEl.textContent = Math.round(1 / perMs / 1000);
        // The line is a squiggle of perfect half-circles laid along the straight running total (worked out in screen
        // pixels so they stay round), alternating above and below it and drifting slowly along. Below the axis is
        // clipped. Today's dot and the right edge of the shading stay fixed at today's total (the line's end sits
        // under the dot). Still for readers who ask for reduced motion, and paused while off screen.
        const plot = chart && chart.querySelector('.m-ledger-plot');
        const line = chart && chart.querySelector('[data-plj-chart-line]');
        const area = chart && chart.querySelector('[data-plj-chart-area]');
        const areaClip = chart && chart.querySelector('[data-plj-area-clip]');
        const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let f = 0, visible = true, frame = 0;
        const drawLine = function (time) {
            frame = 0;
            const w = plot.clientWidth, h = plot.clientHeight;
            const ex = f / 100 * w, ey = f / 100 * h;            // today on the straight line, px from bottom-left
            const len = Math.hypot(ex, ey);
            if (w && h && len) {
                const ux = ex / len, uy = ey / len;
                const n = Math.max(1, Math.round(len / (2 * Math.min(6, h / 20))));   // half-circles about 12px across
                const dia = len / n, r = dia / 2;                 // whole number of half-circles along the line
                // Each bump is a true circular arc: a slice of a circle a little bigger than a half-circle, so the
                // peaks are 20% lower (height = 0.8 × half the width) while the curve stays perfectly round.
                const rise = 0.8 * r, R = (r * r + rise * rise) / (2 * rise), sink = R - rise;
                const span = Math.asin(r / R);
                const shift = still ? 0 : (time / 1000 / 7 * 2 * dia) % (2 * dia);   // one up-and-down pair every 7s
                const pts = [];
                const at = function (t, off) {
                    pts.push([ux * t - uy * off, uy * t + ux * off]);
                };
                const offAt = function (t) {                       // height of the squiggle above/below the line at t
                    const k = Math.floor((t - shift) / dia);
                    const c = shift + k * dia + r;
                    return (k % 2 === 0 ? 1 : -1) * Math.max(0, Math.sqrt(Math.max(0, R * R - (t - c) * (t - c))) - sink);
                };
                at(0, offAt(0));
                for (let k = -2; k * dia + shift < len; k++) {
                    const c = shift + k * dia + r, side = (k % 2 === 0) ? 1 : -1;
                    for (let j = 0; j <= 24; j++) {
                        const a = -span + 2 * span * j / 24;
                        const t = c + R * Math.sin(a);
                        if (t > 0 && t < len) at(t, side * (R * Math.cos(a) - sink));
                    }
                }
                at(len, offAt(len));
                let d = '';
                pts.forEach(function (p, i) {
                    d += (i ? ' L' : 'M') + (p[0] / w * 100).toFixed(3) + ',' + (100 - p[1] / h * 100).toFixed(3);
                });
                line.setAttribute('d', d);
                area.setAttribute('d', d + ' L' + f.toFixed(3) + ',' + (100 - f).toFixed(3) + ' L' + f.toFixed(3) + ',100 L0,100 Z');
                areaClip.setAttribute('width', (f + 10).toFixed(3));   // shading never pokes past today's line
            }
            if (!still && visible) frame = window.requestAnimationFrame(drawLine);
        };
        const render = function () {
            const elapsed = Math.max(0, Date.now() - start);
            counter.textContent = Math.floor(elapsed * perMs).toLocaleString('en-US');
            if (chart) {
                f = Math.min(1, elapsed / yearMs) * 100;
                chart.style.setProperty('--plj-year', (f / 100).toFixed(5));
                if (still) drawLine(0);
            }
        };
        render();
        setInterval(render, 1000);
        if (chart) {
            if (!still) frame = window.requestAnimationFrame(drawLine);
            if (still && 'ResizeObserver' in window) new ResizeObserver(function () { drawLine(0); }).observe(plot);
            if (!still && 'IntersectionObserver' in window) {
                new IntersectionObserver(function (entries) {
                    visible = entries[0].isIntersecting;
                    if (visible && !frame) frame = window.requestAnimationFrame(drawLine);
                }).observe(chart);
            }
        }
    });

    // Ledger map: colour state tiles from comma-separated lists of state codes in the theme settings
    document.querySelectorAll('[data-plj-map]').forEach(function (map) {
        const lists = {
            ban: map.getAttribute('data-ban'),
            six: map.getAttribute('data-six'),
            twelve: map.getAttribute('data-twelve')
        };
        Object.keys(lists).forEach(function (key) {
            const codes = String(lists[key] || '').toUpperCase().split(/[^A-Z]+/).filter(Boolean);
            codes.forEach(function (code) {
                const tile = map.querySelector('[data-st="' + code + '"]');
                if (tile) tile.classList.add('is-' + key);
            });
            const count = map.parentNode.querySelector('[data-plj-count="' + key + '"]');
            if (count) count.textContent = codes.length;
        });
    });
})();

/* Homepage Latest column: mark the list when some stories are hidden so it fades out (see home.css) */
(function () {
    const list = document.querySelector('.m-fp-list');
    if (!list) return;
    function check() {
        list.classList.toggle('is-clipped', list.scrollHeight > list.clientHeight + 2);
    }
    check();
    window.addEventListener('load', check);
    window.addEventListener('resize', check);
    if (document.fonts) document.fonts.ready.then(check);
})();

/* Light / dark mode switch (the initial theme is set by an inline script in default.hbs) */
(function () {
    const root = document.documentElement;
    const buttons = document.querySelectorAll('[data-plj-theme-toggle]');
    const meta = document.querySelector('[data-plj-theme-color]');
    function apply(theme, save) {
        root.setAttribute('data-theme', theme);
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(theme === 'dark')); });
        if (meta) meta.setAttribute('content', theme === 'dark' ? '#1a1211' : '#f2e7cf');
        if (save) { try { localStorage.setItem('plj-theme', theme); } catch (e) {} }
    }
    apply(root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light', false);
    buttons.forEach(function (b) {
        b.addEventListener('click', function () {
            apply(root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark', true);
        });
    });
    // Follow the device setting until the reader picks one
    if (window.matchMedia) {
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
            let saved = null;
            try { saved = localStorage.getItem('plj-theme'); } catch (err) {}
            if (!saved) apply(e.matches ? 'dark' : 'light', false);
        });
    }
})();

/* Mobile menu drawer */
(function () {
    const root = document.documentElement;
    const drawer = document.querySelector('.plj-drawer');
    const burgers = document.querySelectorAll('.gh-burger');   // masthead + scroll bar
    if (!drawer || !burgers.length) return;
    let opener = burgers[0];

    const backdrop = document.querySelector('.plj-drawer-backdrop');
    const closeButton = drawer.querySelector('.plj-drawer-close');

    function setOpen(open) {
        root.classList.toggle('plj-menu-open', open);
        drawer.setAttribute('aria-hidden', String(!open));
        burgers.forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
        if (open) {
            closeButton && closeButton.focus();
        } else {
            opener.focus({preventScroll: true});
        }
    }

    burgers.forEach(function (b) {
        b.addEventListener('click', function () {
            opener = b;
            setOpen(true);
        });
    });
    closeButton && closeButton.addEventListener('click', function () { setOpen(false); });
    backdrop && backdrop.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('plj-menu-open')) setOpen(false);
    });
    // Close before Ghost search / portal opens from inside the drawer
    drawer.addEventListener('click', function (e) {
        if (e.target.closest('a, [data-ghost-search], [data-portal]')) {
            root.classList.remove('plj-menu-open');
            drawer.setAttribute('aria-hidden', 'true');
            burgers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        }
    });
    window.matchMedia('(min-width: 900px)').addEventListener('change', function (e) {
        if (e.matches) root.classList.remove('plj-menu-open');
    });
})();

/* Slim header bar: slides in once the main header scrolls out of view */
(function () {
    const nav = document.querySelector('[data-plj-sticky]');
    const masthead = document.querySelector('[data-plj-masthead]');
    if (!nav || !masthead || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
        const stuck = !entries[0].isIntersecting;
        nav.classList.toggle('is-stuck', stuck);
        nav.inert = !stuck;
    }, {threshold: 0}).observe(masthead);
})();

/* Reading progress bar on posts */
(function () {
    const bar = document.querySelector('.plj-progress');
    const article = document.querySelector('.gh-content');
    if (!bar || !article) return;

    let ticking = false;
    function update() {
        const rect = article.getBoundingClientRect();
        const total = rect.height - window.innerHeight * 0.6;
        const progress = Math.min(1, Math.max(0, -rect.top / (total > 0 ? total : 1)));
        bar.style.setProperty('--plj-progress', progress.toFixed(4));
        ticking = false;
    }
    window.addEventListener('scroll', function () {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
        }
    }, {passive: true});
    update();
})();

/* Copy link buttons */
(function () {
    document.addEventListener('click', function (e) {
        const button = e.target.closest('[data-plj-copy]');
        if (!button) return;
        const url = button.getAttribute('data-plj-copy');
        const done = function () {
            button.classList.add('is-copied');
            setTimeout(function () { button.classList.remove('is-copied'); }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(done).catch(function () { window.prompt('Copy this link:', url); });
        } else {
            window.prompt('Copy this link:', url);
        }
    });
})();

/* Lightbox for gallery and feature images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img, .gh-feature-image'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Infinite scroll on section, author and all-stories pages */
(function () {
    const body = document.body.classList;
    if (body.contains('tag-template') || body.contains('author-template') || body.contains('paged')) {
        pagination();
    }
})();

/* Responsive HTML tables */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();











